import React, { Component } from 'react'
import Page from '../components/Page'
import TrialForm from '../partials/TrialForm'
import LanguageSelector from "../i18n/LanguageSelector";

export default class Trial extends Component {
  render () {
    return (
      <Page size='full'>
        <LanguageSelector/>
        <TrialForm type="regular" />
      </Page>
    )
  }
}
